export const environment = {
  production: true,
  BASE_URL: 'https://irememberpanel.com/api',
  apiUrl: 'https://irememberpanel.com/api'
};